import axios from "./index";

class PaymentApi {
  static GetExpenses = (token, page = 1) => {
    return axios.get(`${base}/expenses/?p=${page}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };
  static GetExpenseById = (token, id) => {
    return axios.get(`${base}/expenses/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };
  static CreateExpense = (token, data) => {
    return axios.post(`${base}/expenses/`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };
  static UpdateExpense = (token, id, data) => {
    return axios.put(`${base}/expenses/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };
  static DeleteExpense = (token, id) => {
    return axios.delete(`${base}/expenses/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };
}

let base = "payment";

export default PaymentApi;
